import React from 'react';
import { createRoot } from 'react-dom/client';
import SearchPage from '../components/SearchPage.jsx';

function mountSearchPage() {
  const element = document.getElementById('search-page-root');
  if (!element || element.dataset.reactMounted) return;

  element.dataset.reactMounted = 'true';
  createRoot(element).render(
    <SearchPage config={{
      locale: element.dataset.locale,
      optionsUrl: element.dataset.optionsUrl,
      drinksUrl: element.dataset.drinksUrl,
      freewordUrl: element.dataset.freewordUrl,
      extendedSearchUrl: element.dataset.extendedSearchUrl
    }} />
  );
}

document.addEventListener('DOMContentLoaded', mountSearchPage);
document.addEventListener('turbolinks:load', mountSearchPage);
